module.exports = __webpack_public_path__ + "img/flickr.2727272.png";